import { Instagram, Mail, MapPin } from "lucide-react";
import {
  CONTACT_EMAIL,
  INSTAGRAM_URL,
  LOCATION,
  LOGO_URL,
} from "@/components/landing/content";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-slate-900 text-slate-200"
    >
      <div className="mx-auto max-w-7xl px-5 md:px-8 py-14 md:py-16 grid md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-3">
            <img
              src={LOGO_URL}
              alt="JT Brand Scales"
              className="h-12 w-12 rounded-xl object-cover bg-white p-1"
            />
            <div className="leading-tight">
              <div className="font-display font-extrabold text-white text-lg">
                JT Brand Scales
              </div>
              <div className="text-xs text-slate-400 tracking-[0.2em] uppercase">
                Kentucky Marketing Agency
              </div>
            </div>
          </div>
          <p className="mt-5 text-slate-400 max-w-xs font-body">
            Helping local businesses scale through smart branding, design and
            marketing that actually moves the needle.
          </p>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.22em] font-semibold text-orange-400">
            Explore
          </div>
          <ul className="mt-4 space-y-2.5 text-sm">
            {[
              ["Services", "#services"],
              ["Pricing", "#pricing"],
              ["Reviews", "#reviews"],
              ["About", "#about"],
              ["Contact", "#contact"],
            ].map(([label, href]) => (
              <li key={href}>
                <a
                  href={href}
                  data-testid={`footer-${label.toLowerCase()}`}
                  className="text-slate-300 hover:text-orange-400 transition-colors"
                >
                  {label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.22em] font-semibold text-orange-400">
            Reach us
          </div>
          <ul className="mt-4 space-y-3 text-sm">
            <li className="flex items-center gap-2.5">
              <MapPin size={14} className="text-orange-400" />
              <span>{LOCATION}</span>
            </li>
            <li className="flex items-center gap-2.5">
              <Mail size={14} className="text-orange-400" />
              <a
                data-testid="footer-email"
                href={`mailto:${CONTACT_EMAIL}`}
                className="hover:text-orange-400 transition-colors"
              >
                {CONTACT_EMAIL}
              </a>
            </li>
            <li className="flex items-center gap-2.5">
              <Instagram size={14} className="text-orange-400" />
              <a
                data-testid="footer-instagram"
                href={INSTAGRAM_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-orange-400 transition-colors"
              >
                @jtbrandscalesky
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-slate-800">
        <div className="mx-auto max-w-7xl px-5 md:px-8 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-slate-500">
          <div>
            © {new Date().getFullYear()} JT Brand Scales · All rights reserved.
          </div>
          <div className="text-slate-600">
            Crafted in Lexington, KY ·{" "}
            <span className="text-orange-400">Built to scale.</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
